import { withErrorBoundary } from "@sentry/nextjs";
import { FC } from "react";
import { GeneralRoutingLinkButton } from "../GeneralRoutingLinkButton";
import { PipelineRoutingLinkButtonProps } from "./types";
import { usePipelineRoutingLink } from "./usePipelineRoutingLink";

const PipelineRoutingLinkButton: FC<PipelineRoutingLinkButtonProps> = withErrorBoundary((props) => {
  const { children, ...rest } = props;

  const pipelineRoutingLinkProps = usePipelineRoutingLink(props);

  return (
    <GeneralRoutingLinkButton {...rest} {...pipelineRoutingLinkProps}>
      {children}
    </GeneralRoutingLinkButton>
  );
}, {});

export { PipelineRoutingLinkButton };
